<template>
  <div class="wallpaper-gallery">
    <!-- 顶部标题 -->
    <!-- <header class="gallery-header">
      <h1>{{ $t('_qz._jbqz') }}</h1>
    </header> -->

    <!-- 搜索和筛选区域 -->
    <div class="filter-section">
      <!-- <div class="search-box">
        <input v-model="searchQuery" type="text" :placeholder="$t('_qz._ssqz')" class="search-input" @input="handleSearch" />
        <button class="search-btn" @click="handleSearch">
          <span class="search-icon">🔍</span>
        </button>
      </div> -->

      <div class="category-filter">
        <button v-for="category in categories" :key="category.id" :class="['category-btn', { active: selectedCategory === category.id }]" @click="selectCategory(category.id)">
          {{ category.name }}
        </button>
      </div>
    </div>

    <!-- 墙纸网格 -->
    <div class="wallpaper-grid">
      <div v-for="wallpaper in filteredWallpapers" :key="wallpaper.id" class="wallpaper-item" @click="previewWallpaper(wallpaper)">
        <div class="image-container">
          <img :src="wallpaper.url" :alt="wallpaper.title" class="wallpaper-image" />
          <div class="image-overlay">
            <button class="preview-btn">{{ $t('_qz._yl') }}</button>
          </div>
        </div>
        <div class="item-info">
          <h3 class="item-title">{{ wallpaper.title }}</h3>
          <div class="item-meta">
            <span class="resolution">{{ wallpaper.resolution }}</span>
            <span class="likes">❤️ {{ wallpaper.likes }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 预览模态框 -->
    <div v-if="selectedWallpaper" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="closeModal">×</button>
        <img :src="selectedWallpaper.url" :alt="selectedWallpaper.title" class="modal-image" />
        <div class="modal-info">
          <h2>{{ selectedWallpaper.title }}</h2>
          <p class="resolution">{{ $t('_qz._fbl') }}: {{ selectedWallpaper.resolution }}</p>
          <p class="category">{{ $t('_qz._fl') }}: {{ getCategoryName(selectedWallpaper.category) }}</p>
          <button class="download-btn" @click="downloadWallpaper(selectedWallpaper)">{{ $t('_qz._xzqz') }}</button>
        </div>
      </div>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading">{{ $t('_qz._jzz') }}...</div>

    <!-- 空状态 -->
    <div v-if="!loading && filteredWallpapers.length === 0" class="empty-state">
      <p>{{ $t('_qz._myzdpp') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WallpaperGallery',
  data() {
    return {
      searchQuery: '',
      selectedCategory: 'all',
      selectedWallpaper: null,
      loading: false,
      categories: [
        { id: 'all', name: this.$t('_qz._qb') },
        { id: 'nature', name: this.$t('_qz._zrfg') },
        { id: 'abstract', name: this.$t('_qz._cxys') },
        { id: 'city', name: this.$t('_qz._csjz') },
        { id: 'anime', name: this.$t('_qz._dmyx') },
        { id: 'space', name: this.$t('_qz._yzxk') }
      ],
      wallpapers: [
        {
          id: 1,
          title: this.$t('_qz._smrc'),
          url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80',
          downloadUrl: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&h=1080&q=80',
          category: 'nature',
          resolution: '1920x1080',
          likes: 1245
        },
        {
          id: 2,
          title: this.$t('_qz._cxjh'),
          url: 'https://images.unsplash.com/photo-1550684376-efcbd6e3f031?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80',
          downloadUrl: 'https://images.unsplash.com/photo-1550684376-efcbd6e3f031?ixlib=rb-4.0.3&auto=format&fit=crop&w=2560&h=1440&q=80',
          category: 'abstract',
          resolution: '2560x1440',
          likes: 892
        },
        {
          id: 3,
          title: this.$t('_qz._dsyj'),
          url: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80',
          downloadUrl: 'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?ixlib=rb-4.0.3&auto=format&fit=crop&w=3840&h=2160&q=80',
          category: 'city',
          resolution: '3840x2160',
          likes: 1567
        },
        {
          id: 4,
          title: this.$t('_qz._dmfy'),
          url: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80',
          downloadUrl: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&h=1080&q=80',
          category: 'anime',
          resolution: '1920x1080',
          likes: 2341
        },
        {
          id: 5,
          title: this.$t('_qz._hhxk'),
          url: 'https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80',
          downloadUrl: 'https://images.unsplash.com/photo-1446776653964-20c1d3a81b06?ixlib=rb-4.0.3&auto=format&fit=crop&w=3840&h=2160&q=80',
          category: 'space',
          resolution: '3840x2160',
          likes: 1876
        },
        {
          id: 6,
          title: this.$t('_qz._slmw'),
          url: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80',
          downloadUrl: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2560&h=1440&q=80',
          category: 'nature',
          resolution: '2560x1440',
          likes: 945
        },
        {
          id: 7,
          title: this.$t('_qz._scld'),
          url: 'https://images.unsplash.com/photo-1532274402911-5a369e4c4bb5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80',
          downloadUrl: 'https://images.unsplash.com/photo-1532274402911-5a369e4c4bb5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&h=1080&q=80',
          category: 'abstract',
          resolution: '1920x1080',
          likes: 1123
        },
        {
          id: 8,
          title: this.$t('_qz._xdjz'),
          url: 'https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80',
          downloadUrl: 'https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-4.0.3&auto=format&fit=crop&w=3840&h=2160&q=80',
          category: 'city',
          resolution: '3840x2160',
          likes: 876
        }
      ]
    }
  },
  computed: {
    filteredWallpapers() {
      return this.wallpapers.filter((wallpaper) => {
        const matchesSearch = wallpaper.title.toLowerCase().includes(this.searchQuery.toLowerCase())
        const matchesCategory = this.selectedCategory === 'all' || wallpaper.category === this.selectedCategory
        return matchesSearch && matchesCategory
      })
    }
  },
  methods: {
    selectCategory(categoryId) {
      this.selectedCategory = categoryId
    },
    handleSearch() {
      // 搜索逻辑
      console.log('搜索:', this.searchQuery)
    },
    previewWallpaper(wallpaper) {
      this.selectedWallpaper = wallpaper
    },
    closeModal() {
      this.selectedWallpaper = null
    },
    getCategoryName(categoryId) {
      const category = this.categories.find((cat) => cat.id === categoryId)
      return category ? category.name : '未知'
    },
    downloadWallpaper(wallpaper) {
      // 创建隐藏的下载链接
      const link = document.createElement('a')
      link.href = wallpaper.downloadUrl
      link.download = `${wallpaper.title}_${wallpaper.resolution}.jpg`
      link.style.display = 'none'
      link.target = '_blank'

      // 添加到文档中并触发点击
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      // 模拟下载成功提示
      this.showDownloadSuccess(wallpaper.title)
    },
    showDownloadSuccess(title) {
      // 创建下载成功提示
      const notification = document.createElement('div')
      notification.className = 'download-notification'
      notification.innerHTML = `
        <div class="notification-content">
          <span class="notification-icon">✓</span>
          <span>${title} 开始下载</span>
        </div>
      `

      // 添加样式
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #4CAF50;
        color: white;
        padding: 15px 20px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 10000;
        animation: slideIn 0.3s ease-out;
      `

      document.body.appendChild(notification)

      // 3秒后自动移除
      setTimeout(() => {
        notification.style.animation = 'slideOut 0.3s ease-in'
        setTimeout(() => {
          if (notification.parentNode) {
            notification.parentNode.removeChild(notification)
          }
        }, 300)
      }, 3000)
    }
  },
  mounted() {
    // 添加动画样式
    const style = document.createElement('style')
    style.textContent = `
      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      @keyframes slideOut {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(100%);
          opacity: 0;
        }
      }
      .notification-content {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .notification-icon {
        font-size: 18px;
        font-weight: bold;
      }
    `
    document.head.appendChild(style)

    // 模拟数据加载
    this.loading = true
    setTimeout(() => {
      this.loading = false
    }, 1000)
  }
}
</script>

<style scoped>
.wallpaper-gallery {
  width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Arial', sans-serif;
  background: #0a0a0f;
  min-height: 100vh;
}

/* ===== 隐藏滚动条 ===== */
.wallpaper-gallery {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.wallpaper-gallery::-webkit-scrollbar,
.wallpaper-gallery *::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

/* ===== 所有文字颜色 ===== */
.wallpaper-gallery,
.wallpaper-gallery * {
  color: #e8e8f0;
}

/* ===== 头部 ===== */
.gallery-header {
  text-align: center;
  margin-bottom: 40px;
  padding: 40px 0;
  background: linear-gradient(135deg, #1a1a3e 0%, #2a1a4e 100%);
  color: #e8e8f0;
  border-radius: 15px;
}
.gallery-header h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  font-weight: 700;
  color: #e8e8f0;
}
.gallery-header p {
  font-size: 1.1rem;
  opacity: 0.9;
  color: #b0b0c8;
}

/* ===== 筛选区域 ===== */
.filter-section {
  background: #141424;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.6);
  margin-bottom: 30px;
  border: 1px solid #2a2a48;
}

.search-box {
  display: flex;
  max-width: 500px;
  margin: 0 auto 20px;
  border-radius: 50px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.search-input {
  flex: 1;
  padding: 15px 25px;
  border: none;
  outline: none;
  font-size: 1rem;
  background: #1a1a30;
  color: #e8e8f0;
}
.search-input::placeholder {
  color: #70708a;
}

.search-btn {
  background: #7c6cf0;
  color: #ffffff;
  border: none;
  padding: 0 25px;
  cursor: pointer;
  transition: background 0.3s;
}
.search-btn:hover {
  background: #a29bfe;
}

.category-filter {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}

.category-btn {
  padding: 10px 20px;
  background: #1a1a30;
  border: 2px solid #2a2a48;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;
  color: #b0b0c8;
}
.category-btn:hover {
  background: #7c6cf0;
  color: #ffffff;
  border-color: #7c6cf0;
  transform: translateY(-2px);
}
.category-btn.active {
  background: #7c6cf0;
  color: #ffffff;
  border-color: #7c6cf0;
}

/* ===== 网格 ===== */
.wallpaper-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  margin-bottom: 40px;
}

.wallpaper-item {
  background: #141424;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.6);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #2a2a48;
}
.wallpaper-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.8);
  border-color: #7c6cf0;
}

.image-container {
  position: relative;
  overflow: hidden;
  aspect-ratio: 3/2;
  background: #0a0a0f;
}

.wallpaper-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
.wallpaper-item:hover .wallpaper-image {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.wallpaper-item:hover .image-overlay {
  opacity: 1;
}

.preview-btn {
  background: rgba(124, 108, 240, 0.9);
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.3s;
}
.preview-btn:hover {
  background: #a29bfe;
}

.item-info {
  padding: 15px;
  background: #141424;
}

.item-title {
  font-size: 1.1rem;
  margin-bottom: 8px;
  color: #e8e8f0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  color: #b0b0c8;
}

.resolution {
  background: #1a1a30;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.8rem;
  color: #b0b0c8;
  border: 1px solid #2a2a48;
}

.likes {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #ff6b81;
}

/* ===== 模态框 ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: #141424;
  border-radius: 15px;
  max-width: 90%;
  max-height: 90%;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  border: 1px solid #2a2a48;
}

.modal-image {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
  display: block;
  background: #0a0a0f;
}

.modal-info {
  padding: 25px;
  background: #141424;
}
.modal-info h2 {
  margin-bottom: 10px;
  color: #e8e8f0;
}
.modal-info .resolution,
.modal-info .category {
  color: #b0b0c8;
  margin-bottom: 5px;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.close-btn:hover {
  background: #7c6cf0;
}

.download-btn {
  background: #7c6cf0;
  color: #ffffff;
  border: none;
  padding: 12px 30px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 15px;
  transition: background 0.3s;
}
.download-btn:hover {
  background: #a29bfe;
}

.loading,
.empty-state {
  text-align: center;
  padding: 60px 20px;
  font-size: 1.2rem;
  color: #b0b0c8;
}

.empty-state {
  background: #141424;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.6);
  border: 1px solid #2a2a48;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .wallpaper-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 15px;
  }
  .gallery-header h1 {
    font-size: 2rem;
  }
  .filter-section {
    padding: 20px;
  }
}
@media (max-width: 480px) {
  .wallpaper-grid {
    grid-template-columns: 1fr;
  }
  .category-filter {
    gap: 5px;
  }
  .category-btn {
    padding: 8px 15px;
    font-size: 0.9rem;
  }
  .gallery-header {
    padding: 30px 0;
  }
  .gallery-header h1 {
    font-size: 1.8rem;
  }
}
</style>
